import React from 'react';
import { Tag, Tooltip } from 'antd';
import { ProductActivityStatus } from '@ydistri/api-sdk';
import { format, parseISO } from 'date-fns';
import { useGetProductActivityQuery } from '../../apiDetail';

interface ProductActivityTagProps {
  productId: number;
}

const ProductActivityTag: React.FC<ProductActivityTagProps> = ({ productId }) => {
  const { currentData: activity, isError } = useGetProductActivityQuery(productId, {
    refetchOnMountOrArgChange: true,
  });

  if (isError || activity?.status !== ProductActivityStatus.Inactive) {
    return null;
  }

  return (
    <Tooltip
      title={
        activity.applicationDate
          ? `Attribute snapshot: ${format(parseISO(activity.applicationDate), 'yyyy-MM-dd')}`
          : undefined
      }
    >
      <Tag color="warning">Inactive</Tag>
    </Tooltip>
  );
};

export default ProductActivityTag;
